(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-selector-2023/assets/javascripts/draw-selector-link-item.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-selector-2023/assets/javascripts/draw-selector-link-item.js');

'use strict';

const TipsenLink = svs.components.tipsen.tipsen_link.TipsenLink;
const analytics = svs.components.analytics;
const composeHref = svs.components.tipsen.drawCard.utils.composeHref;
const If = svs.components.lbUtils.reactConditionals.If;
const DrawSelectorLinkItem = _ref => {
  let drawNumber = _ref.drawNumber,
    productId = _ref.productId,
    children = _ref.children,
    isLinkItem = _ref.isLinkItem,
    _ref$drawTitleForAnal = _ref.drawTitleForAnalytics,
    drawTitleForAnalytics = _ref$drawTitleForAnal === void 0 ? '' : _ref$drawTitleForAnal,
    onToggleDrawSelector = _ref.onToggleDrawSelector;
  const createDrawSearchParam = () => {
    const newHref = composeHref(drawNumber, productId);
    return newHref.replace('?', '');
  };
  const onClick = () => {
    analytics.trackEvent({
      category: "Nya tipsen",
      action: 'change_draw',
      opt_label: drawTitleForAnalytics
    });
    onToggleDrawSelector();
  };
  return React.createElement(React.Fragment, null, React.createElement(If, {
    condition: isLinkItem
  }, React.createElement(TipsenLink, {
    onClick: onClick,
    tabIndex: "-1",
    to: {
      pathname: '',
      search: "?".concat(createDrawSearchParam())
    }
  }, children)), React.createElement(If, {
    condition: !isLinkItem
  }, children));
};
setGlobal('svs.components.tipsen.drawSelector.DrawSelectorLinkItem', DrawSelectorLinkItem);

 })(window);